<script>

import Dialog from 'primevue/dialog';
import ProgressBar from 'primevue/progressbar';
import Button from 'primevue/button';


export default {
  name: "ProgressDialog",
  props: {
    visible: Boolean,
    value: {
      type: Number,
      default: 0,
    },
    // cancelUploadFlag: Boolean,
    currentFileName: String,
  },
  emits: ['cancelUpload'],
  components: {
    Dialog,
    ProgressBar,
    Button
  },
  // updated() {
  //
  //   console.log('currentFileName', this.currentFileName)
  //
  // },
  methods: {
    cancelUpload() {
      this.$emit('cancelUpload')
    }
  }
}
</script>

<template>

    <template>

      <Dialog :visible="visible"  :style="{ width: '50rem' }" :modal="true" :closable="false">

        <div class="title">
          Submitting support ticket...
        </div>

        <div class="title">
          {{currentFileName}}
        </div>

<!--        <div class="progress-percents">20%</div>-->
        <div class="progress-percents">{{value}}%</div>

<!--        <ProgressBar mode="determinate" :value="value"></ProgressBar>-->
        <ProgressBar mode="determinate" :value="value"></ProgressBar>

        <div class="btn-wrap">
          <Button label="Cancel" class="btn blue trt" outlined @click="cancelUpload"/>
        </div>

      </Dialog>

    </template>

</template>

<style scoped>
:deep(.p-button-outlined) {
  color: #0A4CB5;
}

:deep(.p-progressbar-value.p-progressbar-value-animate) {
  background: #0A4CB5;
  transition: width 0.4s ease-in-out !important;
}

/*
:deep(.p-progressbar-determinate.p-progressbar-value-animate) {
  transition: width 0.4s ease-in-out !important;
}
*/

</style>

<style>
/*
.p-progressbar-determinate .p-progressbar-value-animate{
  transition: width 0.4s ease-in-out !important;
}
.p-progressbar .p-progressbar-value {
  background: #0A4CB5 !important;
} */

@import url('https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&display=swap');

.p-dialog {
  width: 100% !important;
  max-width: 860px;
}

.p-dialog .p-dialog-header {
  display: none;
}

.p-dialog .p-dialog-content:last-of-type {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.p-dialog .p-progressbar {
  border-radius: 0;
}


.p-dialog .p-dialog-content {
  padding: 80px;
  text-align: center;
  color: #212529;
}

.p-dialog .p-progressbar .p-progressbar-label {
  display: 0;
  text-indent: -99999px;
}

.p-dialog .title {
  font-family: Raleway;
  text-align: center;
  font-variant-numeric: lining-nums proportional-nums;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 44px;
  margin: 0 0 24px;
}

.p-dialog .progress-percents {
  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  margin: 0 0 16px;
}

.p-dialog .p-progressbar {
  background-color: #F0F5FF;
  border: 1px solid #D6DDEC;
  margin: 0 0 32px;
}

.p-dialog .p-progressbar-value {
  background-color: #0A4CB5;
}

.p-dialog .btn {
  border-radius: 0;
  padding: 8px 20px !important;
  height: 40px;
  width: 100%;
  max-width: 200px;
  outline: 0;
}

.p-dialog .btn:focus,
.p-dialog .btn:active {
  background: transparent; 
  box-shadow: none;
}

@media screen and (max-width: 1023px) {
  .p-dialog .p-dialog-content {
    padding: 40px;
  }

  .p-dialog .title {
    font-size: 28px;
    line-height: 40px;
  }
}

</style>
